import React, { useEffect } from 'react';
import { Button, Form, Input, Modal } from 'antd';
import { IEmailFollowUp } from '@/interfaces/email-follow-up';
import {
  addEmailFollowUp,
  editEmailFollowUp,
} from '@/adapters/email-follow-up';
import { useMutation } from '@tanstack/react-query';
import { IDataModal } from '@/interfaces/dataModal';
import CountrySelector from '@/components/selector/country-selector';

interface IProps {
  dataModal?: IDataModal<IEmailFollowUp>;
  handleOk: () => void;
  handleCancel: () => void;
}

const App = ({ dataModal, handleOk, handleCancel }: IProps) => {
  const [form] = Form.useForm<IEmailFollowUp>();
  const mutations = useMutation({
    mutationFn: async (data: IEmailFollowUp) =>
      dataModal?.id
        ? await editEmailFollowUp(data)
        : await addEmailFollowUp(data),
    mutationKey: ['action-email-follow-up'],
    onSuccess: data => {
      if (![204, 200].includes(data?.status)) {
        throw new Error();
      } else {
        handleOk();
      }
    },
    onError: error => {
      console.log(error);
    },
  });

  const handleUpdate = async () => {
    form
      .validateFields()
      .then(async (values: IEmailFollowUp) => {
        await mutations.mutateAsync(values);
      })
      .catch(info => {
        console.log('Validate Failed:', info);
      });
  };

  const onReset = () => {
    form.resetFields();
  };

  useEffect(() => {
    if (dataModal?.id) {
      form.setFieldsValue({ ...dataModal?.item });
    }
  }, [dataModal?.id]);

  return (
    <Modal
      title={
        dataModal?.id ? `แก้ไข ${dataModal?.item?.countryName}` : 'เพิ่มใหม่'
      }
      open={dataModal?.open}
      onOk={() => handleUpdate()}
      onCancel={handleCancel}
      okText="บันทึก"
      cancelText="ยกเลิก"
      footer={[
        <Button key="back" onClick={handleCancel}>
          ยกเลิก
        </Button>,
        <Button
          key="submit"
          type="primary"
          form="emailFollowUp"
          loading={mutations.isPending}
          onClick={handleUpdate}
        >
          บันทึก
        </Button>,
      ]}
      afterClose={onReset}
    >
      <div className="flex w-full">
        <Form
          form={form}
          name="emailFollowUp"
          onFinish={handleUpdate}
          layout="vertical"
          className="w-full"
        >
          <Form.Item<IEmailFollowUp> name={'countryCode'} hidden>
            <Input />
          </Form.Item>
          <Form.Item<IEmailFollowUp>
            label="Country Code"
            name="countryName"
            rules={[{ required: true, message: 'ระบุ Country' }]}
          >
            <CountrySelector
              disabled={!!dataModal?.id}
              isOther
              handleSelectData={function (id: string, country): void {
                form.setFieldsValue({
                  countryCode: country?.code || 'TH',
                  countryName: id || 'TH',
                });
              }}
            />
          </Form.Item>
          <Form.Item<IEmailFollowUp>
            label="Email To."
            name="to"
            rules={[{ required: true, message: 'ระบุ Email To.' }]}
          >
            <Input.TextArea role="2" size="large" placeholder="Email To" />
          </Form.Item>
          <Form.Item<IEmailFollowUp> label="Email Cc." name="cc">
            <Input.TextArea role="2" size="large" placeholder="Email Cc" />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default App;
